export const RED_YOGAM = ['Marana', 'Prabalarishta'];
export const GREEN_YOGAM = ['Siddha', 'Amirtha'];
export const GREEN_HORA = ['Jupiter', 'Venus'];
export const GREEN_NAKSHATRA = ['Pushya'];
export const GREEN_CHOGHADIYA = ['Amrit', 'Shubh', 'Labh'];

export const RED_FLAG_REASONS = [
  'Rahu Kaal',
  'Yamagandam',
  'Gulikai',
  'Bhadra',
  'Panchaka',
  'Varjyam',
  'Tamil Yogam: Marana/Prabalarishta',
];

export const GREEN_FLAG_REASONS = [
  'Nalla Neram',
  'Jupiter Hora',
  'Venus Hora',
  'Pushya Nakshatra',
  'Tamil Yogam: Siddha/Amirtha',
  'Sarvartha Siddhi',
  'Amrit Siddhi',
  'Auspicious Choghadiya',
];

function ap(p) {
  return (p && p.active_periods) || {};
}

export function getActiveRedFlags(panchanga) {
  if (!panchanga) return [];
  const a = ap(panchanga);
  const flags = [];
  if (a.rahu_kaal) flags.push('Rahu Kaal');
  if (a.yamagandam) flags.push('Yamagandam');
  if (a.gulikai) flags.push('Gulikai');
  if (a.bhadra) flags.push('Bhadra');
  if (a.panchaka) flags.push('Panchaka');
  if (a.varjyam) flags.push('Varjyam');
  const yogamEn = panchanga.tamil_yogam && panchanga.tamil_yogam.primary_en;
  if (yogamEn && RED_YOGAM.includes(yogamEn)) {
    flags.push('Tamil Yogam: Marana/Prabalarishta');
  }
  return flags;
}

export function getActiveGreenFlags(panchanga) {
  if (!panchanga) return [];
  const a = ap(panchanga);
  const flags = [];
  if (a.nalla_neram) flags.push('Nalla Neram');
  const horaEn = panchanga.hora && panchanga.hora.planet_en;
  if (horaEn === 'Jupiter') flags.push('Jupiter Hora');
  if (horaEn === 'Venus') flags.push('Venus Hora');
  const nakEn = panchanga.nakshatra && panchanga.nakshatra.name_en;
  if (nakEn && GREEN_NAKSHATRA.includes(nakEn)) flags.push('Pushya Nakshatra');
  const yogamEn = panchanga.tamil_yogam && panchanga.tamil_yogam.primary_en;
  if (yogamEn && GREEN_YOGAM.includes(yogamEn)) {
    flags.push('Tamil Yogam: Siddha/Amirtha');
  }
  if (a.sarvartha_siddhi) flags.push('Sarvartha Siddhi');
  if (a.amrit_siddhi) flags.push('Amrit Siddhi');
  const chogh = panchanga.choghadiya && panchanga.choghadiya.current_name;
  if (chogh && GREEN_CHOGHADIYA.includes(chogh)) flags.push('Auspicious Choghadiya');
  return flags;
}

export function classifyMuhurta(panchanga) {
  if (!panchanga) return 'yellow';
  if (getActiveRedFlags(panchanga).length > 0) return 'red';
  if (getActiveGreenFlags(panchanga).length > 0) return 'green';
  return 'yellow';
}
